module.exports = __webpack_public_path__ + "img/blackandgreysleeve.ad971568.jpg";